import { styled } from "goober";

export const ACTIVITY_ROW_GAP = 32;

export const Message = styled("div")`
  border-radius: 8px;
  max-width: 100%;
  min-width: 0;
  display: inline-flex;
  gap: 8px;
  white-space: pre-wrap;
  word-break: break-word;
  color: var(--text-primary);
`;

export const UserMessageTimestamp = styled("div")`
  position: absolute;
  top: 100%;
  right: 12px;
  margin-top: 4px;
  font-family: inherit;
  font-size: 9px;
  line-height: 12px;
  font-weight: 450;
  letter-spacing: -1%;
  color: var(--text-primary);
  opacity: 0;
  transform: translateY(-4px);
  transition:
    opacity var(--motion-fast) var(--ease-out),
    transform var(--motion-fast) var(--ease-out);
  pointer-events: none;
  white-space: nowrap;
`;

export const UserMessageWrapper = styled("div")`
  position: relative;

  &:hover ${UserMessageTimestamp} {
    opacity: 0.3;
    transform: translateY(0);
    transition-delay: 600ms;
  }
`;

export const DateMarker = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
`;

export const DateBadge = styled("span")`
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  height: 20px;
  background: var(--alpha4);
  border-radius: 38px;
  color: var(--text-secondary);
`;

// Fills the messages’ 12px/24px inline padding, the widest the scroller doesn’t clip; the padding, less the border, keeps content where it would sit unwrapped.
export const PrivateSection = styled("div")`
  display: flex;
  flex-direction: column;
  margin-inline: -12px -24px;
  padding: 23px 23px 15px 11px;
  border: 1px dashed var(--alpha8);
  border-radius: 16px;
  background: var(--alpha4);

  & > :last-child {
    margin-bottom: 0 !important;
  }
  /* Its own padding stands in for the date marker’s, so wrapping doesn’t move anything. */
  & > ${DateMarker}:first-child {
    padding-top: 0;
  }
`;

export const PrivateLabel = styled("div")`
  align-self: flex-end;
  margin: 4px -12px 32px 0;
  font-size: 9px;
  line-height: 12px;
  font-weight: 450;
  letter-spacing: -1%;
  color: var(--text-primary);
  opacity: 0.3;
`;
